import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { adminApi, errText } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

export const ChangePassword = () => {
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const save = async (e) => {
    e.preventDefault();
    try {
      await adminApi.put("/auth/password", { current_password: cur, new_password: next });
      toast.success("Password updated");
      setOpen(false);
      setCur("");
      setNext("");
    } catch (ex) {
      toast.error(errText(ex));
    }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" className="text-neutral-300 hover:text-white hover:bg-white/10" data-testid="admin-change-password-button">
          <KeyRound size={16} />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader><DialogTitle>Change admin password</DialogTitle></DialogHeader>
        <form onSubmit={save} className="space-y-3">
          <Input type="password" placeholder="Current password" value={cur} onChange={(e) => setCur(e.target.value)} required data-testid="current-password-input" />
          <Input type="password" placeholder="New password (8+ characters)" value={next} onChange={(e) => setNext(e.target.value)} minLength={8} required data-testid="new-password-input" />
          <Button type="submit" className="w-full rounded-full" data-testid="save-password-button">Save</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
